import { useHasPermission } from '@/client/hooks/useHasPermission';
import { permissionLabel } from '@/client/config/permissions';

export interface Gate {
  /** True when the current user may perform the gated action. */
  allowed: boolean;
  /** True while the user's permissions are still loading (non-superadmins). */
  isLoading: boolean;
  /** Tooltip/aria text explaining what's missing, e.g. "Requires …". */
  reason: string;
  /** The gated code, for callers that want to display it. */
  code: string;
}

// Permission check for a single action (superadmins always allowed). While
// resolving, `isLoading` is true and the control should stay disabled. Pair
// with `<PermissionButton>`. UI only — the backend still enforces.
export function useGate(code: string): Gate {
  const { hasPermission, isSuperAdmin, isLoading } = useHasPermission(code);
  return {
    allowed: isSuperAdmin || hasPermission,
    isLoading: !isSuperAdmin && isLoading,
    reason: `Requires the “${permissionLabel(code)}” permission`,
    code,
  };
}

export default useGate;
